<template>
  <div class="wrap-bg wrap-data-manage wrap-content-list pd15">
    <v-breadcrumb v-if="isShowBread" :breadcrumb-list="breadcrumbList" />
    <div
      v-loading="isFilterLoad"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      class="list-filter-wrap-box breadcrumb-btm-con-box">
      <v-list-filter
        v-model="bindForms"
        :form-arr="formArr"
        :form-rules="formRules"
        :is-add-btn="false"
        :is-group-btn="false"
        :is-show-choose-filter="true"
        :is-show-filter-expand="true"
        label-width="90px"
        ensurn-btn-txt="查询"
        cancel-btn-txt="重置"
        form-item-position="row"
        class="list-filter bg-white pd-column15"
        @changeFormBind="changeFormBind"
        @filterCheckBtn="refreshList"
        @filterResetBtn="filterResetBtn"/>
    </div>
    <!--内容列表-->
    <section class="pd15 bg-white mg-top15">
      <!--表格-->
      <div class="mg-btm15 color-dark f-df f-jcsb">
        <h3 class="f-fwn f-fs16 f-df f-aib">
          <span>查询列表</span>
          <span class="mg-left20 f-fs1">为您找到了
            <i v-if="pageObj.totalSize === -1" class="el-icon-loading"></i>
            <em v-else class="color-blue f-fwn">{{ pageObj.totalSize }}</em>
            条数据，其中，
            <i v-if="pageObj.noCollectSize === -1" class="el-icon-loading"></i>
            <em v-else class="color-blue f-fwn">{{ pageObj.noCollectSize }}</em>
            条未采集，
            <i v-if="pageObj.noCheckSize === -1" class="el-icon-loading"></i>
            <em v-else class="color-blue f-fwn">{{ pageObj.noCheckSize }}</em>
            条待审核
          </span>
        </h3>
        <div class="f-df f-ai pd-right15">
          <!-- <el-checkbox v-model="pageObj.isPopular" @change="changePopular" class="is-popular-type">只看爆款</el-checkbox> -->
          <label>排序指标：</label>
          <!--排序指标-->
          <el-select
            v-model="pageObj.sortIndex"
            placeholder="请选择"
            style="width: 140px;"
            @change="getList()">
            <el-option
              v-for="(elem, i) in sortIndex"
              :key="i"
              :label="elem.name"
              :value="elem.id" />
          </el-select>
          <!--排序顺序-->
          <el-select
            v-model="pageObj.sortRule"
            placeholder="请选择"
            style="width: 100px;"
            class="mg-left10"
            @change="getList()">
            <el-option
              v-for="(elem, i) in sortRules"
              :key="i"
              :label="elem.name"
              :value="elem.id" />
          </el-select>
          <!--导出按钮-->
          <el-button size="small" icon="el-icon-bottom" class="color-blue mg-left15 f-fs14" @click="exportBtn()">导出数据</el-button>
          <!--新增数据按钮-->
          <!-- <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" class="mg-left15 f-fs14" @click="addBtn()">新增</el-button> -->
          <!--批量导入按钮-->
          <!-- <el-button size="small" icon="el-icon-bottom" class="color-blue mg-left15 f-fs14" @click="bacthImport()">批量导入</el-button> -->
        </div>
      </div>
      <v-table-list
        :is-loading="isLoading"
        :table-head="tableHead"
        :table-btn="tableBtn"
        :page-list="pageList"
        :current-page="pageObj.page"
        :page-size="pageObj.pageSize"
        :total-size="pageObj.totalSize"
        :is-show-selection="false"
        :is-table-operation-btn="true"
        class="bg-white pd-row15"
        @rowOperatBtn="rowOperatBtn"
        @sizeChange="sizeChange"
        @currentChange="currentChange" />
    </section>
    <!-- 导出列表 -->
    <export-popip
      ref="popickExport"
      v-model="isShowExportPopTip"
      :is-expor-loading="isExporLoading"
      :export-arr="exportArr"
      @exportEnsure="exportEnsure"
      @exportCancle="exportCancle" />
  </div>
</template>

<script>
import pageConfig from './page.config.js'
import vBreadcrumb from '@/components/breadcrumb.vue'
import vListFilter from '@/components/form-filter/index.vue'
import $filterCommon from '@/components/form-filter/index.js'
import vTableList from '@/components/table-list.vue'
import ExportPopip from '@/components/exportPopip.vue'
import mixin from '@/mixin/list.js'
import {
  getSortLabel,
  getList,
  getListTotal,
  getExportLabel
} from '@/api/dataManage/noteZQ.js'
export default {
  components: {
    vBreadcrumb,
    vListFilter,
    vTableList,
    ExportPopip
  },
  mixins: [mixin],
  data() {
    return {
      isShowBread: false,
      breadcrumbList: [
        {
          name: '数据管理'
        },
        {
          name: '内容数据管理'
        }
      ],
      isFilterLoad: false,
      isLoading: false,
      originBindForms: {}, // 保存最初的条件筛选，方便重置
      bindForms: {},
      formArr: [],
      formRules: {},
      tableHead: [], // 表头
      tableBtn: [], // 表格操作按钮组
      pageList: [], // 产线分析数据
      sortIndex: [],
      sortRules: pageConfig.sortRules,
      pageObj: {
        page: 1,
        pageSize: 10,
        totalSize: -1,
        noCollectSize: -1,
        noCheckSize: -1,
        sortIndex: '', // issue_date按发布时间排序，impl_date按实施时间排序
        sortRule: '1' // 1倒序，2升序
      }
    }
  },
  mounted() {
    this.$bus.$on('updateContentList', data => {
      // 更新列表
      this.getList(this.pageObj.page, this.pageObj.pageSize)
    })
    // 内容列表
    this.tableHead = JSON.parse(JSON.stringify(pageConfig.tableHead))
    this.tableBtn = JSON.parse(JSON.stringify(pageConfig.tableBtn))
    // 获取排序指标
    this.getSortLabel()
    // 获取导出指标
    this.getExportLabel()
    // 页面初始化
    this.init()
  },
  methods: {
    init() {
      this.isFilterLoad = true
      // 请求所有条件
      const filterAjaxList = JSON.parse(JSON.stringify(pageConfig.filterAjaxList))
      Promise.all(filterAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        this.isFilterLoad = false
        const formArr = JSON.parse(JSON.stringify(pageConfig.filterForm))
        // 初始化所有筛选条件集合
        const filterObj = $filterCommon.filterChooseHandle(formArr, data)
        // 初始化当前选择的筛选条件
        this.bindForms = filterObj.filterChooseObj
        this.formArr = filterObj.filterList
        // 记录最初的条件筛选，方便重置
        this.originBindForms = JSON.parse(JSON.stringify(this.bindForms))
        // 页面统一请求初始化并且请求
        this.refreshList()
      })
    },
    // 获取当前所有参数
    getParam() {
      const bindForms = JSON.parse(JSON.stringify(this.bindForms))
      // 发布日期
      bindForms.pubDate = this.dateParamHandle(this.bindForms.pubDate)
      // 地区字段
      if (bindForms.autoArea && bindForms.autoArea.length) {
        if (bindForms.autoArea[0] === '中国') {
          bindForms.authCountry = bindForms.autoArea[0]
          bindForms.authProvince = bindForms.autoArea.length > 1 ? bindForms.autoArea[1] : ''
          bindForms.authCity = bindForms.autoArea.length > 2 ? bindForms.autoArea[2] : ''
        } else {
          bindForms.authCountry = bindForms.autoArea[bindForms.autoArea.length - 1]
        }
      }
      // 返回参数
      return bindForms
    },
    // 获取排序指标
    getSortLabel() {
      getSortLabel().then(res => {
        this.sortIndex = $filterCommon.getDataHandle(res.data || [], 'labelName', 'name')
        this.pageObj.sortIndex = this.sortIndex.length ? this.sortIndex[0].id : ''
      })
    },
    // 获取内容列表
    getList(currentPage, pageSize) {
      this.isLoading = true
      this.pageObj.page = currentPage || 1
      pageSize && (this.pageObj.pageSize = pageSize)
      this.pageList = []
      getList(Object.assign(this.getParam(), {
        startPageNum: this.pageObj.page,
        pageSize: this.pageObj.pageSize,
        sortItem: this.pageObj.sortIndex,
        isSortMax: this.pageObj.sortRule
      })).then(res => {
        this.isLoading = false
        this.pageList = (res.data || []).map((item, index) => {
          item.$index = index + 1
          return item
        })
      })
    },
    // 获取产线分析数据总数
    getListTotal() {
      this.pageObj.totalSize = -1
      this.pageObj.noCollectSize = -1
      this.pageObj.noCheckSize = -1
      getListTotal(this.getParam()).then(res => {
        const data = res.data
        this.pageObj.totalSize = data.total || 0
        this.pageObj.noCollectSize = data.notCrawlTotal || 0
        this.pageObj.noCheckSize = data.notEditTotal || 0
      })
    },
    // 条件重置
    filterResetBtn() {
      this.bindForms = JSON.parse(JSON.stringify(this.originBindForms))
    },
    // 表格按钮
    rowOperatBtn(rowData, item) {
      this.$router.push({
        path: '/dataManage/noteZQDetail',
        query: {
          id: rowData[0].articleId,
          type: item.id
        }
      })
    },
    // 新增
    addBtn() {
      this.$router.push({
        path: '/dataManage/noteZQDetail',
        query: {
          type: 'add'
        }
      })
    },
    // 批量导入
    bacthImport() {
      this.$router.push({
        path: '/dataManage/contentImport'
      })
    },
    // 导出字段筛选
    getExportLabel() {
      getExportLabel().then(res => {
        // 导出数据
        this.exportArr = this.exportHandle(res.data, 'label', 'labelName', 'notNull')
      })
    },
    // 导出弹窗确定按钮
    exportEnsure(seletedChooseExport) {
      const exportRow = seletedChooseExport.reduce((preArr, item) => {
        preArr.push(item.id)
        return preArr
      }, [])
      this.downloadFile(
        '/api/data/red/book/content/zq/list/file',
        Object.assign(this.getParam(), {
          sortItem: this.pageObj.sortIndex,
          isSortMax: this.pageObj.sortRule,
          quota: exportRow
        }),
        '笔记列表（ZQ）.xlsx')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.list-filter-wrap-box{
  min-width: 1500px;
  min-height: 200px;
}
/deep/.form-item-select input.el-input__inner{
  width: 170px;
}
/deep/.el-form-item__label{
  padding-right: 20px;
}
</style>
